import styled from 'styled-components';

export const TextWrapper = styled.div`
  margin-bottom: 20px;
`;
